import React from 'react';
import Select from 'react-select';

export const MOTOR_CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD', symbol: '$', description: 'ABD Doları' },
  { value: 'EUR', label: 'EUR', symbol: '€', description: 'Euro' },
  { value: 'TRY', label: 'TRY', symbol: '₺', description: 'Türk Lirası' },
];

const motorCurrencySelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '38px',
    height: '38px',
    border: state.isFocused ? '1.5px solid #29472d' : '1.5px solid #e2e8f0',
    borderRadius: '8px',
    backgroundColor: state.isFocused ? '#fff' : '#fafbfc',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(41, 71, 45, 0.08)' : 'none',
    cursor: 'pointer',
    transition: 'border-color 0.2s, box-shadow 0.2s, background 0.2s',
    '&:hover': {
      borderColor: state.isFocused ? '#29472d' : '#cbd5e1',
      backgroundColor: '#fff',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '36px',
    padding: '0 10px',
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '36px',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? '#29472d' : '#94a3b8',
    padding: '0 10px',
    transition: 'color 0.2s, transform 0.2s',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
    '&:hover': { color: '#29472d' },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  singleValue: (provided) => ({
    ...provided,
    color: '#1e293b',
    fontWeight: 600,
    fontSize: '0.88rem',
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #e8edf2',
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
    overflow: 'hidden',
    marginTop: '4px',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '6px',
  }),
  option: (provided, state) => ({
    ...provided,
    borderRadius: '6px',
    padding: '10px 12px',
    fontSize: '0.86rem',
    backgroundColor: state.isSelected
      ? '#fff5f0'
      : state.isFocused
        ? '#f8fafc'
        : 'white',
    color: state.isSelected ? '#29472d' : '#334155',
    fontWeight: state.isSelected ? 600 : 500,
    cursor: 'pointer',
  }),
};

const formatOptionLabel = (option, { context }) => (
  <div className="motor-currency-option">
    <span className="motor-currency-symbol">{option.symbol}</span>
    <div className="motor-currency-text">
      <span className="motor-currency-code">{option.label}</span>
      {context === 'menu' && (
        <span className="motor-currency-desc">{option.description}</span>
      )}
    </div>
  </div>
);

const MotorCurrencySelect = React.memo(({ value, onChange }) => {
  const selected = MOTOR_CURRENCY_OPTIONS.find((o) => o.value === value) || MOTOR_CURRENCY_OPTIONS[0];

  return (
    <div className="motor-currency-select-wrap">
      <Select
        value={selected}
        onChange={(opt) => onChange(opt?.value || 'USD')}
        options={MOTOR_CURRENCY_OPTIONS}
        styles={motorCurrencySelectStyles}
        formatOptionLabel={formatOptionLabel}
        isSearchable={false}
        classNamePrefix="motor-currency"
        placeholder="Döviz seçin"
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={document.body}
        aria-label="Motor döviz kuru seçimi"
      />
    </div>
  );
});

export default MotorCurrencySelect;
